import React from 'react'
import styles from './DashedMetric.scss'
import cx from 'classnames'

export class DashedMetric extends React.PureComponent {
  render () {
    const { value, label, width, noMargin, className, labelClassName } = this.props
    const isNonZero = value && /[1-9a-z]/i.test(value)

    return (
      <div
        className={cx(styles.DashedMetric, noMargin && styles.noMargin, className)}
        style={{ width: width && width }}>
        <div className={isNonZero ? styles.value : cx(styles.value, styles.emptyValue)}>
          {isNonZero ? value : '- -'}
        </div>
        <div className={cx(styles.label, labelClassName)}>{label}</div>
      </div>
    )
  }
}
